import React from 'react'

import { ISalaryData } from './salary/salary.interface'

type PayDataContextProps = {
  salaries: Array<ISalaryData>
  setSalaries: (data: Array<ISalaryData>) => void
  modifiedSalaries: string[]
  setModifiedSalaries: (data: string[]) => void
}

const PayDataContext = React.createContext<PayDataContextProps>({
  salaries: [],
  setSalaries: () => {},
  modifiedSalaries: [],
  setModifiedSalaries: () => {},
})

export const PayDataProvider = PayDataContext.Provider
export const PayDataConsumer = PayDataContext.Consumer
export default PayDataContext
